export enum KanbanIconeEnum {
  Inbox = 1,
  RequestQuote = 2,
  ThumbUp = 3,
  Engineering = 4,
  TaskAlt = 5,
  ThumbDown = 6,
  Block = 7,
  Schedule = 8,
  Build = 9,
  PauseCircle = 10,
  Inventory2 = 11,
  LocalShipping = 12,
  SupportAgent = 13,
  FactCheck = 14,
}
